import { ReactNode } from "react";
import { ExternalLink, Phone } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { CALENDAR_URL } from "@/config/books";

/** Opens John's GHL booking calendar for a free, no-obligation, in-person appointment. */
const AppointmentDialog = ({ trigger }: { trigger: ReactNode }) => (
  <Dialog>
    <DialogTrigger asChild>{trigger}</DialogTrigger>
    <DialogContent className="max-w-3xl w-[calc(100vw-1.5rem)] max-h-[92vh] overflow-y-auto p-4 sm:p-6">
      <DialogHeader>
        <p className="eyebrow mb-2">Free · In Person · No Obligation</p>
        <DialogTitle className="font-serif text-2xl md:text-3xl font-light leading-tight">
          Book your appointment with John
        </DialogTitle>
        <DialogDescription className="text-muted-foreground font-light">
          Pick a time that works for you. John will bring a complimentary 100+ page paperback book (a $19.99 value)
          to your meeting.
        </DialogDescription>
      </DialogHeader>
      <iframe
        src={CALENDAR_URL}
        title="Book a free, no-obligation appointment with John Mastroianni"
        className="w-full h-[70vh] min-h-[560px] border border-border rounded-sm bg-background"
      />
      <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-sm">
        <a href="tel:+16093062926" className="inline-flex items-center gap-2 text-foreground hover:text-primary">
          <Phone className="h-4 w-4 text-primary" /> Prefer to talk? (609) 306-2926
        </a>
        <a
          href={CALENDAR_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-primary hover:underline"
        >
          Open the calendar in a new tab <ExternalLink className="h-4 w-4" />
        </a>
      </div>
    </DialogContent>
  </Dialog>
);

export default AppointmentDialog;
